import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import autobind from 'common/decorators/autobind.js';
import Dropdown from 'core/components/Dropdown.js';
import Icon from 'core/components/Icon.js';
import Button from 'core/components/Button.js';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';
import {SELECT_HEALTH_FUND_BTN} from 'core/constants';

export default
@observer
class HospitalHealthFundPicker extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    constructor() {
        super();
        this.state = {
            isOpen: false,
        };
    }

    setPromotedGapSchemeId() {
        const {
            gapSchemeId,
            healthFund,
            promotedGapSchemes,
        } = this.context.rootStore.healthFundStore;
        const promotedGapSchemeId = promotedGapSchemes?.find(
            (pgs) => pgs.healthFundId === healthFund?.id,
        )?.gapSchemeId;
        if (!gapSchemeId && promotedGapSchemeId) {
            this.context.updateStore({
                showOnlyGapScheme: false,
            });
            this.context.rootStore.healthFundStore.updateStore({
                gapSchemeId: promotedGapSchemeId,
            });
        } else if (gapSchemeId && !promotedGapSchemeId) {
            this.context.rootStore.healthFundStore.updateStore({
                gapSchemeId: null,
            });
        }
    }

    componentDidMount() {
        this.setPromotedGapSchemeId();
    }

    @autobind
    async handleSelectHF(fund) {
        this.context.updateStore({
            page: 1,
        });
        await this.context.rootStore.healthFundStore?.selectHealthFund(
            fund?.id || 0,
        );
        this.setPromotedGapSchemeId();
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
        }));
    }

    @autobind
    handleToggle(status) {
        this.setState({
            isOpen: status,
        });
    }

    get hfOptions() {
        const {healthFunds} = this.context.rootStore.healthFundStore;
        const options = [
            {
                name: 'initial',
                content: (
                    <>
                        <Button
                            action={() => this.handleSelectHF({})}
                            text="I don't have private health insurance"
                        />
                        <span className="separator" />
                    </>
                ),
            },
        ];
        healthFunds.forEach((hf) =>
            options.push({
                name: hf.name,
                content: (
                    <Button
                        action={() => this.handleSelectHF(hf)}
                        text={
                            <>
                                <Icon name="checkmark" />
                                <div
                                    style={{
                                        backgroundImage: `url("${hf.avatar}")`,
                                    }}
                                />
                                {hf.name}
                            </>
                        }
                    />
                ),
            }),
        );
        return options;
    }

    render() {
        const {
            healthFundsLoading,
            healthFund,
        } = this.context.rootStore.healthFundStore;
        if (healthFundsLoading) {
            return null;
        }
        return (
            <Dropdown
                customClass="phi-picker"
                displayText={healthFund?.name || 'Select health fund'}
                gaSelector={SELECT_HEALTH_FUND_BTN}
                handleToggle={this.handleToggle}
                options={this.hfOptions}
                selectedOption={healthFund?.name}
                storeIsOpen={this.state.isOpen}
            />
        );
    }
}
